/* eslint-disable */
import React from 'react';
import { Breadcrumb, Tabs } from 'antd';
import { withQuery } from '@/utils';
import styles from './finances.module.scss';
import TenantTransactions from '@/components/TenantTransactions';
import TenantFinancesSummary from './summary';

function Section({ title, children }) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>{title}</div>
      <div className={styles.sectionBody}>{children}</div>
    </div>
  );
}

function Finances() {
  return (
    <div className={styles.container}>
      <Section title="财务总览">
        <TenantFinancesSummary />
      </Section>
      <Section title="交易记录">
        <div style={{ paddingTop: 10 }}>
          <TenantTransactions />
        </div>
      </Section>
    </div>
  );
}

export default withQuery(Finances);
